import React, { useEffect, useState } from "react";
import { Form, message, Modal } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans, InputDate, UploadFile, UploadButton } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { createDataReq } from "../requests";
import { Commons, Const, Validations } from "../../../constants";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { masterTooltips } from "../../../../common/masterTooltips";

const langKey = Const["wow"].lngKey

const fieldLabel = makeFieldLabel(masterTooltips.announcement, { namespace: "announcement", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createWow";

const CreateWow = (props) => {
  const [loader, setLoader] = useState(false);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onSubmit = (data) => {
    setSaveLoader(true)
    if (data.file_attachment !== undefined && data.file_attachment !== null && data.file_attachment.url === undefined) {
      data.file_attachment.file = data.file_attachment.fileList.length > 0 ? data.file_attachment.file : null
    }
    if (data.file_cover !== undefined && data.file_cover !== null && data.file_cover.url === undefined) {
      data.file_cover.file = data.file_cover.fileList.length > 0 ? data.file_cover.file : null
    }
    const payload = { words_of_wisdom: data };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.words_of_wisdoms.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setSaveLoader(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  //============uploading file============
  const [fileList, setFileList] = useState([]);
  const [coverFileList, setCoverFileList] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [previewTitle, setPreviewTitle] = useState('');
  const handleCancel = () => setPreviewOpen(false);
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  const onChangeCover = ({ fileList: newFileList }) => {
    setCoverFileList(newFileList);
  };
  const onPreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    //setPreviewTitle(file.name || file.url.substring(file.url.lastIndexOf('/') + 1));
  };
  //=========================================
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 600 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit }>

        <Form.Item name="title" rules={ rules.title } label={ fieldLabel("title", trans(`${langKey}.title`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['name']) } size="small"
        >
          <InputText placeholder={ trans(`${langKey}.name`) } />
        </Form.Item>

        <Form.Item name="wow_date" rules={ rules.wow_date } label={ fieldLabel("wow_date", trans(`${langKey}.wow_date`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['wow_date']) } size="small"
        >
          <InputDate format='YYYY-MM-DD' />
        </Form.Item>

        <Form.Item name="expiry_date" rules={ rules.expiry_date } label={ fieldLabel("expiry_date", trans(`${langKey}.expiry_date`)) }
          className="da-mb-16"
          { ...getErrorProps(errors['expiry_date']) } size="small"
        >
          <InputDate format='YYYY-MM-DD' />
        </Form.Item>

        <Form.Item label={ fieldLabel("file_attachment", trans(`${langKey}.attachment`)) } rules={ rules.attachment } name="file_attachment" >
          <UploadFile
            accept=".jpg,.png,.jpeg" listType="picture-card"
            fileList={ fileList }
            onChange={ onChange }
            onPreview={ onPreview }
            multiple={ false }
            beforeUpload={ (file) => {
              return false;
            } }
          >
            { fileList.length === 1 ? null : <UploadButton /> }
          </UploadFile>
        </Form.Item>

        <Form.Item label={ fieldLabel("file_cover", trans(`${langKey}.cover`)) } rules={ rules.cover } name="file_cover" >
          <UploadFile
            accept=".jpg,.png,.jpeg" listType="picture-card"
            fileList={ coverFileList }
            onChange={ onChangeCover }
            onPreview={ onPreview }
            multiple={ false }
            beforeUpload={ (file) => {
              return false;
            } }
          >
            { coverFileList.length === 1 ? null : <UploadButton /> }
          </UploadFile>
        </Form.Item>

        <Form.Item name="description" rules={ rules.description } label={ fieldLabel("description", trans(Commons.description)) }
          className="da-mb-16"
          { ...getErrorProps(errors['description']) } size="small"
        >
          <InputTextArea placeholder={ trans(`${langKey}.description`) } />
        </Form.Item>

      </Form>

      <Modal open={ previewOpen } title={ previewTitle } footer={ null } onCancel={ handleCancel }>
        <img
          alt="example"
          style={ {
            width: '100%',
          } }
          src={ previewImage }
        />
      </Modal>
    </ModalComponent>
  )
}

export default CreateWow

const rules = {
  title: [
    { required: true, message: trans(Validations.title) },
  ],
  wow_date: [
    { required: true, message: trans(`${langKey}.wow_date.req`) },
  ],
  expiry_date: [
    { required: true, message: trans(`${langKey}.expiry_date.req`) },
  ],


};

const formLayout = {
  // layout: "horizontal",
  labelCol: { span: 6 },
  wrapperCol: { span: 14, offset: 2 },
  labelAlign: "left"
}